<div
  class="tw-flex"
  *ngIf="allowPublic"
>
  <div class="tw-flex tw-flex-1">
    <p-inputSwitch
      *ngIf="!loadingPublicUrl"
      [formControl]="sharePublicControl"
      class="tw-flex tw-self-center"
    />
    <div
      *ngIf="loadingPublicUrl"
      class="tw-flex tw-items-center"
    >
      <span class="tw-text-xl tw-text-gray-600 fa-spin fa-solid fa-circle-notch"></span>
    </div>
    <div class="tw-ml-2">
      <h4 class="tw-text-lg tw-mb-0">Share via Public Link</h4>
      <span class="tw-text-sm">Anyone with the link can access this {{ type.toLowerCase() }}</span>
    </div>
  </div>
  <p-button
    [label]="publicUrlCopied ? 'Copied!' : 'Copy public link'"
    icon="fa fa-copy"
    severity="secondary"
    [outlined]="!publicUrlCopied"
    (onClick)="copyLink(publicUrl)"
    class="tw-content-center"
    *ngIf="sharePublicControl.value && publicUrl"
  ></p-button>
</div>

<ng-container *ngComponentOutlet="urlModifierComponent" />

<p-divider *ngIf="allowPublic" />

<div
  class="tw-flex tw-pb-2"
  *ngIf="allowTeamSharing"
>
  <div class="tw-flex tw-flex-col tw-flex-1 tw-mb-1">
    <h4 class="tw-mb-0">Share with team members</h4>
    <span class="tw-text-sm">The team members will need to login before accessing the {{ type.toLowerCase() }}</span>
  </div>
  <p-button
    [label]="shareUrlCopied ? 'Copied!' : 'Copy private link'"
    icon="fa fa-copy"
    severity="secondary"
    [outlined]="!shareUrlCopied"
    (onClick)="copyLink(shareUrl)"
    class="tw-content-center"
    *ngIf="shareUrl"
  ></p-button>
</div>
<div
  class="tw-flex tw-flex-col tw-border tw-border-gray-200 tw-border-solid tw-rounded-lg tw-p-4 tw-mb-4 tw-max-h-64 tw-overflow-y-auto"
  *ngIf="sharedUsersAndSuites.length"
>
  <div
    *ngFor="let userOrSuite of sharedUsersAndSuites; let i = index; let last = last; trackBy: trackBySharedItems"
    class="tw-flex"
    [ngClass]="{
      'tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-b tw-border-gray-200 tw-border-solid tw-mb-4 tw-pb-4': !last
    }"
  >
    <i
      [ngClass]="userOrSuite.type === 'user' ? 'fa-user' : 'fa-user-group'"
      class="fa-solid tw-content-center tw-text-gray-500"
    ></i>
    <div class="tw-text-gray-600 tw-content-center tw-flex-1 tw-pl-4">
      <h5 class="tw-mb-0">{{ userOrSuite.name }}</h5>
      <p
        class="tw-mb-0 tw-text-sm"
        *ngIf="userOrSuite.email"
      >
        {{ userOrSuite.email }}
      </p>
    </div>
    <p-dropdown
      [(ngModel)]="dropdownCustomModel[userOrSuite.id]"
      [loading]="!removingAllUsersAndSuites && updatingUserPermissions[userOrSuite.id]"
      loadingIcon="fa-solid fa-circle-notch fa-spin"
      (onChange)="dropdownModelChange($event?.value?.value, userOrSuite)"
      [options]="dropdownCustomOptions"
      optionLabel="name"
      appendTo="body"
    ></p-dropdown>
  </div>
</div>

<ng-container *ngIf="allowTeamSharing">
  <div class="tw-flex tw-flex-col">
    <p-multiSelect
      [options]="groupedUsersAndSuites"
      [group]="true"
      [showClear]="true"
      [filter]="true"
      [filterBy]="'name,email,label'"
      [formControl]="usersAndSuitesControl"
      [loading]="loadingUsersAndSuites"
      loadingIcon="fa-solid fa-circle-notch fa-spin"
      [placeholder]="sharedUsersAndSuites?.length ? 'Add users and suites' : 'Select users and suites'"
      (onClear)="usersAndSuitesCleared()"
      styleClass="tw-w-full"
      class="tw-w-full"
      optionLabel="name"
    >
      <ng-template
        pTemplate="item"
        let-item
      >
        <span>{{ item.name }}</span>
        <span
          class="tw-ml-1 tw-text-gray-500"
          *ngIf="item.email"
        >
          ({{ item.email }})
        </span>
      </ng-template>
    </p-multiSelect>
  </div>
  <div *ngIf="usersAndSuitesControl.value?.length">
    <textarea
      [(ngModel)]="note"
      placeholder="Add a note to invite"
      pInputTextarea
      class="tw-w-full tw-mt-4 tw-h-20"
    ></textarea>
  </div>
</ng-container>

<p-divider *ngIf="allowTeamSharing" />

<div
  *ngIf="!loadingPublicUrl && !loadingUsersAndSuites"
  class="tw-flex tw-flex-col"
>
  <h4>Sharing Permissions</h4>
  <div
    [formGroup]="permissionsForm"
    class="tw-flex tw-flex-col tw-gap-2"
  >
    <div
      class="tw-flex"
      [ngClass]="{ 'tw-hidden': type === SNAPSHOT }"
    >
      <p-checkbox
        formControlName="dates"
        inputId="dates"
        name="dates"
        binary="true"
      />
      <label
        for="dates"
        class="tw-ml-2"
      >
        Allow viewers to adjust date range
      </label>
    </div>
    <div
      *ngIf="type === DASHBOARD"
      class="tw-flex"
    >
      <p-checkbox
        formControlName="global_filters"
        inputId="globalFilters"
        name="globalFilters"
        binary="true"
      />
      <label
        for="globalFilters"
        class="tw-ml-2"
      >
        Show applied global and page filters
      </label>
    </div>
  </div>
  <div
    *ngIf="type === SNAPSHOT"
    class="tw-flex tw-flex-col"
    [formGroup]="snapshotPermissionsForm"
  >
    <div class="tw-flex tw-my-2">
      <p-checkbox
        formControlName="comparisons"
        inputId="comparisons"
        name="comparisons"
        binary="true"
      />
      <label
        for="comparisons"
        class="tw-ml-2"
      >
        Comparisons
      </label>
      <i
        class="fa-solid fa-circle-info tw-ml-2"
        pTooltip="Allow viewers to compare different date ranges"
      ></i>
    </div>
    <div class="tw-font-semibold tw-my-2">Views</div>
    <div class="tw-flex tw-flex-col tw-gap-2">
      <p-dropdown
        [formControl]="snapshotPermissionsForm.get('views')"
        [options]="viewOptions"
        styleClass="tw-w-full"
      ></p-dropdown>
    </div>
    <ng-container *ngIf="datasets?.length">
      <div class="tw-font-semibold tw-mt-4 tw-mb-2">Vendors</div>
      <div
        class="tw-flex tw-flex-col tw-border tw-border-gray-200 tw-border-solid tw-rounded-lg tw-p-4 tw-bg-gray-50 tw-mb-4 tw-max-h-48 tw-overflow-y-auto"
      >
        <ng-container formGroupName="datasets">
          <div
            class="tw-flex tw-mb-4"
            *ngFor="let dataset of datasets"
          >
            <p-checkbox
              [formControlName]="dataset"
              [inputId]="dataset"
              [name]="dataset"
              binary="true"
            />
            <label
              [for]="dataset"
              class="tw-ml-2 tw-capitalize"
            >
              {{ getDatasetDisplayName(dataset) }}
            </label>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
<div class="tw-flex tw-flex-col tw-pt-5">
  <div
    class="tw-flex tw-gap-2 tw-justify-end"
    *ngIf="usersAndSuitesControl.value?.length"
  >
    <p-button
      label="Share without invite"
      severity="primary"
      outlined="true"
      [loading]="sendingInvites"
      (onClick)="sendInvite(true)"
    ></p-button>
    <p-button
      label="Share and send invite"
      severity="primary"
      [loading]="sendingInvites"
      (onClick)="sendInvite(false)"
    ></p-button>
  </div>
  <div
    class="tw-flex tw-gap-2 tw-justify-end"
    *ngIf="!usersAndSuitesControl.value?.length"
  >
    <p-button
      [loading]="removingAllUsersAndSuites"
      label="Remove all"
      severity="danger"
      outlined="true"
      (onClick)="removeAllUsersAndSuites()"
      *ngIf="sharedUsersAndSuites.length"
    ></p-button>
    <p-button
      label="Done"
      severity="secondary"
      outlined="true"
      (onClick)="close()"
      [disabled]="type === SNAPSHOT && snapshotPermissionsForm.invalid && public"
    ></p-button>
  </div>
</div>
